import { Page } from "shared/react";
import { type CreatorEntity, LEADERBOARD_MAX } from "shared/schema";
import { LeaderboardChallengeList } from "../challenge/ChallengeList.js";
import { EntityHeader } from "../entity/EntityHeader.js";
import { USER } from "../util/user.js";
import { useGroupContext } from "./GroupContext.js";

export function GroupLeaderboardsPage(): React.ReactElement {
	const { id: gid } = useGroupContext();
	const creator: CreatorEntity = `group:${gid}`;
	return (
		<Page title="Joined leaderboards" path="./leaderboards">
			<EntityHeader entity={creator}>
				<h1>Joined leaderboards</h1>
			</EntityHeader>
			<section>
				<LeaderboardChallengeList //
					query={{ creator, uid: USER.data.uid, tid: "a", $order: "!updated", $limit: LEADERBOARD_MAX }}
					empty="No leaderboards joined"
				/>
			</section>
		</Page>
	);
}
